import React from 'react';
import PropTypes from 'prop-types';

const Link = ({ options, arrowDirection }) => {

  const { label = '', url = '#' } = options;

  const arrow = (
    <i className="icon-arrow accent-color" />
  );

  return (
    <a href={url}>
      {
        arrowDirection === 'left' &&
        arrow
      }
      {` ${label} `}
      {
        arrowDirection === 'right' &&
        arrow
      }
    </a>
  );
};

Link.propTypes = {
  options: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    url: PropTypes.string,
  }),
  arrowDirection: PropTypes.string,
};

Link.defaultProps = {
  options: {},
  arrowDirection: 'left',
};

export default Link;



// WEBPACK FOOTER //
// ./js/components/step1/compare/Link.js